import { isEmpty } from 'lodash';

const PROMO_STATUS_I18N_KEY = {
  Aktif: 'filter.active',
  Dijadwalkan: 'filter.scheduled',
  Nonaktif: 'filter.inactive',
};

const getPromoStatusResponse = (response, t) => {
  if (isEmpty(response?.data?.status)) return [];

  return response.data.status.map((opt) => ({
    value: opt?.name,
    label: t ? t(PROMO_STATUS_I18N_KEY[opt?.name] ?? opt?.name) : opt?.name,
  }));
};

export default getPromoStatusResponse;
